import React, { useEffect, useRef } from 'react';
import { View, Animated, Platform } from 'react-native';
import { useStyleSheet, useThemeContext } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
export const checkPasswordStrength = (password) => {
    let strength = 0;
    if (password.length < 8) {
        return PasswordStrength.WEAK;
    }
    if (password.match(/[a-z]+/)) {
        strength += 1;
    }
    if (password.match(/[A-Z]+/)) {
        strength += 1;
    }
    if (password.match(/[0-9]+/)) {
        strength += 1;
    }
    if (password.match(/[$@#&!]+/)) {
        strength += 1;
    }
    switch (strength) {
        case 1:
            return PasswordStrength.WEAK;
        case 2:
            return PasswordStrength.MEDIUM;
        case 3:
            return PasswordStrength.STRONG;
        case 4:
            return PasswordStrength.VERY_STRONG;
        default:
            return PasswordStrength.WEAK;
    }
};
export var PasswordStrength;
(function (PasswordStrength) {
    PasswordStrength["WEAK"] = "WEAK";
    PasswordStrength["MEDIUM"] = "MEDIUM";
    PasswordStrength["STRONG"] = "STRONG";
    PasswordStrength["VERY_STRONG"] = "VERY_STRONG";
})(PasswordStrength || (PasswordStrength = {}));
export const TitleByPasswordStrength = {
    [PasswordStrength.WEAK]: 'Very Weak',
    [PasswordStrength.MEDIUM]: 'Weak',
    [PasswordStrength.STRONG]: 'Strong',
    [PasswordStrength.VERY_STRONG]: 'Excellent'
};
export function PasswordAdvisor({ password, style }) {
    const styles = useStyleSheet(getStyles);
    const { size } = useThemeContext();
    const width = useRef(new Animated.Value(0)).current;
    const widthConfig = React.useMemo(() => ({
        [PasswordStrength.WEAK]: {
            width: size.H
        },
        [PasswordStrength.MEDIUM]: {
            width: size.H * 2
        },
        [PasswordStrength.STRONG]: {
            width: size.H * 3
        },
        [PasswordStrength.VERY_STRONG]: {
            width: size.H * 4
        }
    }), [size]);
    const strength = React.useMemo(() => checkPasswordStrength(password), [password]);
    const title = React.useMemo(() => TitleByPasswordStrength[strength], [strength]);
    useEffect(() => {
        Animated.timing(width, {
            toValue: widthConfig[strength].width,
            duration: 750,
            useNativeDriver: Platform.OS !== 'web'
        }).start();
    }, [strength, width]);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(View, { style: styles.textsContainer },
            React.createElement(Text, { type: 'body', size: 'sm', weight: 'semibold', style: styles.strength }, "Strength"),
            React.createElement(Text, { type: 'body', size: 'sm', weight: 'semibold' }, title)),
        React.createElement(View, { style: styles.indicatorContainer },
            React.createElement(Animated.View, { style: [styles.indicator, styles[strength], { width: width }] }))));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    textsContainer: { flexDirection: 'row' },
    strength: {
        color: color.invert2.p56,
        marginRight: size.B
    },
    text2: {
        color: color.invert2.p100,
        marginLeft: size.B
    },
    indicatorContainer: {
        height: 5,
        width: size.H * 4,
        backgroundColor: color.invert2.p4,
        borderRadius: 8
    },
    indicator: { height: 5, borderRadius: 8 },
    [PasswordStrength.WEAK]: {
        backgroundColor: color.negative.solid
    },
    [PasswordStrength.MEDIUM]: {
        backgroundColor: color.negative.solid
    },
    [PasswordStrength.STRONG]: {
        backgroundColor: color.warning.solid
    },
    [PasswordStrength.VERY_STRONG]: {
        backgroundColor: color.success.solid
    }
}));
//# sourceMappingURL=index.js.map